import { render, staticRenderFns } from "./indicator.vue?vue&type=template&id=19a04aa4&scoped=true&"
import script from "./indicator.vue?vue&type=script&lang=js&"
export * from "./indicator.vue?vue&type=script&lang=js&"
import style0 from "./indicator.vue?vue&type=style&index=0&id=19a04aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a04aa4",
  null
  
)

/* custom blocks */
import block0 from "./indicator.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)
import block1 from "./indicator.vue?vue&type=custom&index=1&blockType=graphql"
if (typeof block1 === 'function') block1(component)

export default component.exports